// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bdf4f3c2","488":"98cb5246","553":"e2ad94f2","977":"1741e0c6"}[chunkId] + ".chunk.js";
};